import { Route } from '@angular/router';
import { Permission } from '../../models/permission.model';
import { PermissionGuard } from '../../shared/guards/permission.guard';

export const communicationCenterRoute: Route = {
  path: 'communication-center',
  canActivate: [PermissionGuard],
  data: {
    permissions: [
      Permission.OPERATIONS_ONBOARDING,
      Permission.ADMIN,
      Permission.CLIENT_ADMIN,
      Permission.PORTFOLIO_MANAGER,
      Permission.PORTFOLIO_ASSISTANT,
      Permission.CLIENT,
    ],
  },
  children: [
    { path: '', redirectTo: 'list', pathMatch: 'full' },
    {
      path: 'list',
      canActivate: [PermissionGuard],
      data: {
        permissions: [
          Permission.OPERATIONS_ONBOARDING,
          Permission.ADMIN,
          Permission.CLIENT_ADMIN,
          Permission.PORTFOLIO_MANAGER,
          Permission.PORTFOLIO_ASSISTANT,
        ],
      },
      children: [
        {
          path: '',
          loadComponent: () =>
            import('./communication-center.component').then((c) => c.CommunicationCenterComponent),
        },
        {
          path: ':id',
          loadComponent: () =>
            import('./details/details.component').then(
              (c) => c.CommunicationCenterDetailsComponent,
            ),
        },
      ],
    },
    {
      path: 'my-messages',
      canActivate: [PermissionGuard],
      data: { permissions: [Permission.CLIENT] },
      children: [
        {
          path: '',
          loadComponent: () =>
            import('./my-messages/my-messages.component').then((c) => c.MyMessagesComponent),
        },
        {
          path: ':id',
          loadComponent: () =>
            import('./details/details.component').then(
              (c) => c.CommunicationCenterDetailsComponent,
            ),
        },
      ],
    },
  ],
};
